import TextField from "@material-ui/core/TextField";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff, Lock, Language, AccountCircle, Settings } from "@material-ui/icons";
import React from "react";
import styled, { keyframes } from "styled-components";
import FieldsConfigurationECC from "./_components/fields-configurantio";

function TabECC({
	values,
	touched,
	errors,
	handleChange,
	initialValues,
	setFieldValue,
}) {
	const [passwordVisibility, setPasswordVisibility] = React.useState({
		login_ecc: false,
		password_ecc: false,
	});

	const togglePasswordVisibility = (field) => {
		setPasswordVisibility((prev) => ({
			...prev,
			[field]: !prev[field],
		}));
	};

	return (
		<ModernFormContainer>
			<SectionCard>
				<SectionHeader>
					<SectionIcon color="#3498db">
						<Settings />
					</SectionIcon>
					<SectionTitle>Configurações SAP ECC</SectionTitle>
				</SectionHeader>
				<FormGrid columns={2}>
					<StyledFieldContainer>
						<FieldLabel>
							<AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
							Login ECC
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="login_ecc"
							name="login_ecc"
							placeholder="Usuário do ECC"
							value={values.login_ecc}
							onChange={handleChange}
							error={touched.login_ecc && Boolean(errors.login_ecc)}
							helperText={touched.login_ecc && errors.login_ecc}
							autoComplete="off"
							variant="outlined"
							type={passwordVisibility.login_ecc ? "text" : "password"}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() => togglePasswordVisibility("login_ecc")}
											edge="end"
										>
											{passwordVisibility.login_ecc ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</StyledFieldContainer>

					<StyledFieldContainer>
						<FieldLabel>
							<Lock style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />
							Senha ECC
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="password_ecc"
							name="password_ecc"
							placeholder="Senha do ECC"
							value={values.password_ecc}
							onChange={handleChange}
							error={touched.password_ecc && Boolean(errors.password_ecc)}
							helperText={touched.password_ecc && errors.password_ecc}
							autoComplete="off"
							variant="outlined"
							type={passwordVisibility.password_ecc ? "text" : "password"}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() => togglePasswordVisibility("password_ecc")}
											edge="end"
										>
											{passwordVisibility.password_ecc ? <VisibilityOff /> : <Visibility />}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</StyledFieldContainer>

					<StyledFieldContainer fullWidth>
						<FieldLabel>
							<Language style={{ fontSize: '18px', marginRight: '8px', color: '#16a085' }} />
							URL ECC
						</FieldLabel>
						<TextField
							InputLabelProps={{ shrink: true }}
							fullWidth
							id="url_ecc"
							name="url_ecc"
							placeholder="https://ecc-server:port"
							value={values.url_ecc}
							onChange={handleChange}
							error={touched.url_ecc && Boolean(errors.url_ecc)}
							helperText={touched.url_ecc && errors.url_ecc}
							autoComplete="off"
							variant="outlined"
						/>
					</StyledFieldContainer>
				</FormGrid>
			</SectionCard>

			<FieldsConfigurationECC
				values={values}
				handleChange={handleChange}
				errors={errors}
				setFieldValue={setFieldValue}
				initialValues={initialValues}
			/>
		</ModernFormContainer>
	);
}

export default TabECC;

// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const ModernFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
	background: white;
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	border: 1px solid #e8e8e8;
	animation: ${fadeIn} 0.5s ease;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 16px;
	border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${props => props.color ? `${props.color}15` : '#667eea15'};
	color: ${props => props.color || '#667eea'};
	margin-right: 12px;
	transition: all 0.3s ease;

	svg {
		font-size: 22px;
	}

	${SectionCard}:hover & {
		transform: scale(1.1);
	}
`;

const SectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
	display: grid;
	grid-template-columns: ${props => props.columns === 2 ? 'repeat(2, 1fr)' : '1fr'};
	gap: 20px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const StyledFieldContainer = styled.div`
	display: flex;
	flex-direction: column;
	grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};

	.MuiOutlinedInput-root {
		border-radius: 10px;
		transition: all 0.3s ease;

		&:hover {
			box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
		}

		&.Mui-focused {
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
		}
	}

	.MuiInputLabel-outlined {
		font-family: 'Mulish', sans-serif;
		font-weight: 500;
	}

	.MuiOutlinedInput-input {
		font-family: 'Mulish', sans-serif;
	}
`;

const FieldLabel = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #2c3e50;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;
`;
